export function buildRootBodyLabels({ bodyTree, nodes, hiddenTypes, rootBodyToGlobalName }) {
  if (hiddenTypes.has("object")) return [];

  return bodyTree
    .map((body) => {
      const rootNode = nodes.find((node) => node.uuid === body.uuid && node.type === "body");
      if (!rootNode) return null;
      return {
        rootBodyUuid: body.uuid,
        x: rootNode.x,
        y: rootNode.y,
        name: rootBodyToGlobalName.get(body.uuid) ?? body.name,
      };
    })
    .filter(Boolean);
}

export function applyParallelArcLanes(edges) {
  const PARALLEL_CURVE_EDGE_TYPES = new Set(["tendon-joint", "equality-ref"]);
  const parallelPairKey = (idA, idB) => (idA < idB ? `${idA}:${idB}` : `${idB}:${idA}`);
  const parallelBuckets = new Map();
  edges.forEach((edge, index) => {
    if (!PARALLEL_CURVE_EDGE_TYPES.has(edge.edgeType)) return;
    const key = parallelPairKey(edge.from, edge.to);
    let bucket = parallelBuckets.get(key);
    if (!bucket) {
      bucket = [];
      parallelBuckets.set(key, bucket);
    }
    bucket.push(index);
  });

  parallelBuckets.forEach((indices) => {
    if (indices.length <= 1) return;
    const count = indices.length;
    indices.forEach((edgeIndex, lane) => {
      edges[edgeIndex] = {
        ...edges[edgeIndex],
        parallelArcLane: lane,
        parallelArcCount: count,
      };
    });
  });
}
